import { BullModule } from "@nestjs/bull";
import { jobConfigs } from '../../../config';
import { BULLJSQUEUENAMES } from '@gtpl/shared-models/common-models';
export const assetManagementQueues = [
    BullModule.registerQueueAsync({
        name: BULLJSQUEUENAMES.ASSET_ACTIVITY_CONTROLLER_JOB,
        useFactory: () => ({
            name: BULLJSQUEUENAMES.ASSET_ACTIVITY_CONTROLLER_JOB,
            redis: {
                ...jobConfigs.redis
            },
            defaultJobOptions: {
                ...jobConfigs.bullJobOptions
            },
            settings: {
                ...jobConfigs.bullAdvancedSettings
            }
        }),
    }),
]